import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const isActive = (path) => {
    return location.pathname === `/${path}`;
  };

  const handleNavigation = (path) => {
    navigate(path === "home" ? "/" : `/${path}`);
    // Scroll to top of page after navigation
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="bg-white py-16 border-t">
      <div className="max-w-7xl mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
        {/* Logo and Social Media */}
        <div className="flex flex-col items-center md:items-start">
          <img
            src="/logo_tax_horizontal.png"
            alt="Tax Solutions"
            className="h-20 mb-8 cursor-pointer hover:opacity-90 transition-opacity"
            onClick={() => handleNavigation("home")}
          />
          <div className="flex space-x-6">
            <a
              href="https://www.facebook.com/share/AvagZVX5zXyhePcE/?mibextid=LQQJ4d"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@tax.solutions.as?_t=8rp4is7Cfc6&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.298-.002.595.042.88.13V9.4a6.17 6.17 0 0 0-1-.05A6.34 6.34 0 0 0 3 15.69a6.34 6.34 0 0 0 10.82 4.49 6.47 6.47 0 0 0 2.18-4.81v-7c1.263.806 2.739 1.233 4.24 1.23V6.69H19.59z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/yoel_alvarez_tax_solutions?mdxt=MWlnbDdibG0yeDVxYw%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.897 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.897-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="text-center">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6">
            {t.footer.quickLinks}
          </h3>
          <ul className="space-y-4">
            <li>
              <button
                onClick={() => handleNavigation("about")}
                className={`text-lg text-gray-600 hover:text-gray-900 transition-colors ${
                  isActive("about") ? "text-cyan-400" : ""
                }`}
              >
                {t.nav.about}
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavigation("services")}
                className={`text-lg text-gray-600 hover:text-gray-900 transition-colors ${
                  isActive("services") ? "text-cyan-400" : ""
                }`}
              >
                {t.nav.services}
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavigation("faq")}
                className={`text-lg text-gray-600 hover:text-gray-900 transition-colors ${
                  isActive("faq") ? "text-cyan-400" : ""
                }`}
              >
                {t.nav.faq}
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavigation("contact")}
                className={`text-lg text-gray-600 hover:text-gray-900 transition-colors ${
                  isActive("contact") ? "text-cyan-400" : ""
                }`}
              >
                {t.nav.contact}
              </button>
            </li>
          </ul>
        </div>

        {/* Appointment */}
        <div className="text-center md:text-right">
          <button
            onClick={() => handleNavigation("contact")}
            className="bg-red-400 text-white px-8 py-4 rounded-lg inline-block hover:bg-red-500 transition-colors text-lg shadow-md hover:shadow-lg"
          >
            {t.common.bookAppointment}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
